import type { ActivityModule } from '../../core/activity';
import { mountFractionsFind } from './ui';
import levelsData from './levels.json';
import './style.css';

export const fractionsFind: ActivityModule = {
  id: 'fractions_find',
  title: 'Encontre a fração',
  description: 'Olhe o desenho e escreva a fração (numerador/denominador) que ele representa.',
  ageMin: 8,
  ageMax: 11,
  difficulty: 5,
  iconPath: 'assets/gcompris-AGPL/fractions_find/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountFractionsFind,
};
